export default {
    fullSizeEditorMinWidth: 1274,
    referenceWidth: 480
};
